document.addEventListener('DOMContentLoaded', function () {
    const variantSelector = document.querySelector('[name="id"]');
    if (!variantSelector) return;
  
    variantSelector.addEventListener('change', function (e) {
      const selectedVariantId = e.target.value;
  
      document.querySelectorAll('.variant-metafields').forEach(el => {
        // Ensure the element and dataset exist
        if (!el || !el.dataset || !el.dataset.variantId) return;
  
        if (el.dataset.variantId === selectedVariantId) {
          el.classList.remove('hidden');
        } else {
          el.classList.add('hidden');
        }
      });
    });
  });
  